// extracted by mini-css-extract-plugin
module.exports = {"border-gray":"#ddd","popoverToggle":"Popover-module__popoverToggle___2BUL8","popover":"Popover-module__popover___2a_lP","active":"Popover-module__active___1rVvP"};